import { useContext } from 'react'

import DocumentGenerateContext from 'contexts/DocumentGenerateContext'

const useDocumentGenerate = () => {
  const context = useContext(DocumentGenerateContext)

  if (context === undefined) {
    throw new Error(
      'useDocumentGenerate must be used within a DocumentGenerateContext.Provider',
    )
  }

  return {
    activeStep: context.activeStep,
    controlOrigin: context.controlOrigin,
    controlOriginPath: context.controlOriginPath,
    disabledNextButton: context.disabledNextButton,
    documentCategories: context.documentCategories,
    documentGenerated: context.documentGenerated,
    documentTemplate: context.documentTemplate,
    documentVariables: context.documentVariables,
    documentVariablesFilled: context.documentVariablesFilled,
    enableNextButton: context.enableNextButton,
    handleAdvanceStep: context.handleAdvanceStep,
    handleBack: context.handleBack,
    handleNext: context.handleNext,
    handleReturnStep: context.handleReturnStep,
    hiddenBackButton: context.hiddenBackButton,
    isStepComplete: context.isStepComplete,
    lastActiveStep: context.lastActiveStep,
    nextButtonText: context.nextButtonText,
    resetAdvanceStep: context.resetAdvanceStep,
    resetBackButton: context.resetBackButton,
    resetNextButtonText: context.resetNextButtonText,
    resetReturnStep: context.resetReturnStep,
    setActiveStep: context.setActiveStep,
    setControlOrigin: context.setControlOrigin,
    setDisabledNextButton: context.setDisabledNextButton,
    setDocumentGenerated: context.setDocumentGenerated,
    setDocumentTemplate: context.setDocumentTemplate,
    setDocumentVariables: context.setDocumentVariables,
    setDocumentVariablesFilled: context.setDocumentVariablesFilled,
    setLastActiveStep: context.setLastActiveStep,
    setNextButtonText: context.setNextButtonText,
    setShowBackButton: context.setShowBackButton,
    setWantsToAdvanceStep: context.setWantsToAdvanceStep,
    setWantsToReturnStep: context.setWantsToReturnStep,
    showBackButton: context.showBackButton,
    wantsToAdvanceStep: context.wantsToAdvanceStep,
    wantsToReturnStep: context.wantsToReturnStep,
  }
}

export default useDocumentGenerate
